import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 🎯 استدعاء الترجمة
import axios from 'axios';
import { Building2, ArrowRight } from 'lucide-react';

const OrganizationsList = () => {
  const { t, i18n } = useTranslation();
  const [orgs, setOrgs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/organizations').then(res => setOrgs(res.data));
  }, []);

  // تحديد اتجاه النص بناءً على اللغة
  const isRTL = i18n.language === 'ar' || i18n.language === 'ur';

  return (
    <div className={`p-4 bg-[#f3f4f6] h-full overflow-y-auto ${isRTL ? 'text-right' : 'text-left'}`}>
      <div className="bg-white border border-gray-300 shadow-sm">
        <div className={`p-3 bg-gray-50 border-b flex items-center justify-between `}>
          <h2 className={`text-xs font-black text-gray-700 uppercase tracking-widest flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
            <Building2 size={16} className="text-[#1a3353]"/> 
            {t('organizations.title')}
          </h2>
        </div>
        <table className="w-full text-[11px] border-collapse">
          <thead className="bg-[#e9ecef] text-gray-600 border-b">
            <tr className={`${isRTL ? 'flex-row-reverse' : ''}`}>
              <th className={`p-2 border-r uppercase ${isRTL ? 'text-right' : 'text-left'}`}>{t('organizations.org_id')}</th>
              <th className={`p-2 border-r uppercase ${isRTL ? 'text-right' : 'text-left'}`}>{t('organizations.description')}</th>
              <th className="p-2 text-center uppercase border-r">{t('organizations.active')}</th>
              <th className="p-2 w-10"></th>
            </tr>
          </thead>
          <tbody>
            {orgs.map((org) => (
              <tr key={org.org_id} onClick={() => navigate(`/organizations/${org.org_id}`)} 
                  className="border-b hover:bg-blue-50 cursor-pointer group transition-colors">
                <td className={`p-2 border-r font-bold text-blue-900 ${isRTL ? 'text-right' : 'text-left'}`}>{org.org_id}</td>
                <td className={`p-2 border-r text-gray-600 ${isRTL ? 'text-right' : 'text-left'}`}>{org.description}</td>
                <td className="p-2 border-r text-center">
                   <span className={`px-2 py-0.5 rounded-full font-bold text-[10px] ${org.active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                    {org.active ? t('common.yes') : t('common.no')}
                   </span>
                </td>
                <td className="p-2 text-center text-gray-300 group-hover:text-blue-600">
                  <ArrowRight size={14} className={isRTL ? 'rotate-180' : ''}/>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrganizationsList;